import { render, staticRenderFns } from "./appr-fishing.vue?vue&type=template&id=0be71615&scoped=true"
import script from "./appr-fishing.vue?vue&type=script&lang=js"
export * from "./appr-fishing.vue?vue&type=script&lang=js"
import style0 from "./appr-fishing.vue?vue&type=style&index=0&id=0be71615&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be71615",
  null
  
)

export default component.exports